import { KeyboardEvent } from 'react';

import isString from '../../utils/isString';

import { TableProps } from './Table.type';

import styles from './TableBody.module.css';

type Props<T extends Record<string, unknown>> = Pick<TableProps<T>, 'rows' | 'onClick' | 'striped'>;

export function TableBody<T extends Record<string, unknown>>({ rows, onClick, striped }: Props<T>) {
  const onKeyDown = ({ event, data }: { event: KeyboardEvent<HTMLTableRowElement>; data?: T }) => {
    if (onClick && event.key === 'Enter') {
      onClick(data);
      if (document.activeElement) {
        (document.activeElement as HTMLElement).blur();
      }
    }
  };

  return (
    <tbody className={styles.tbody}>
      {rows.map(({ row, data }, index) => (
        <tr
          key={'rows' + index}
          role={onClick ? 'button' : undefined}
          aria-label={onClick ? 'View detail' : undefined}
          tabIndex={onClick ? 0 : undefined}
          onKeyDown={onClick ? event => onKeyDown({ event, data }) : undefined}
          className={`${styles.tr} ${onClick ? styles.withClick : ''} ${
            striped === 'odd' ? styles.odd : styles.even
          }`}
          onClick={onClick ? () => onClick(data) : undefined}
        >
          {row.map(({ content, width, icon, isHidden }, index) =>
            isHidden ? null : (
              <td
                width={width}
                className={styles.td}
                key={isString(content) ? content + index : index}
              >
                {icon && <img src={icon.src} alt={icon.alt} />}
                {content}
              </td>
            ),
          )}
        </tr>
      ))}
    </tbody>
  );
}
